<template>
  <div id="baseline-new-home-3k-payment" class="mx-auto max-w-screen-xl">
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
  </div>
</template>

<style>
#baseline-new-home-3k-payment {

}
</style>

<script setup>
import { useQuery } from "@vue/apollo-composable";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";
import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);

const { result, loading } = useQuery(GET_ORGANISMS, {
  uri: "/baseline-new-home-3k-payment/",
});

const organisms = computed(() => {
  return result.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

breadcrumbsList.value = [{ title: "Baseline New Home 3k Payment", link: "" }];
</script>
